import { render, staticRenderFns } from "./DzListGroupItem.vue?vue&type=template&id=3eb56d90&scoped=true"
import script from "./DzListGroupItem.vue?vue&type=script&lang=js"
export * from "./DzListGroupItem.vue?vue&type=script&lang=js"
import style0 from "./DzListGroupItem.vue?vue&type=style&index=0&id=3eb56d90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb56d90",
  null
  
)

export default component.exports